import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 xl:p-8" };
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3" };
const _hoisted_3 = { class: "text-sm font-medium text-eorange-600" };
const _hoisted_4 = { class: "text-2xl font-semibold text-eblack-900" };
const _hoisted_5 = { class: "flex flex-wrap items-center gap-2" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = ["disabled"];
const _hoisted_8 = { class: "grid gap-3 md:grid-cols-2 xl:grid-cols-4" };
const _hoisted_9 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_10 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_11 = { class: "mt-1 text-xs text-eblack-500" };
const _hoisted_12 = {
    key: 0,
    class: "flex flex-wrap items-center justify-between gap-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
    "data-test": "notification-deliveries-error"
};
const _hoisted_13 = { class: "rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_14 = { class: "grid gap-3 border-b border-ewhite-100 p-4 lg:grid-cols-[minmax(180px,1fr)_160px_160px_auto]" };
const _hoisted_15 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_16 = ["placeholder"];
const _hoisted_17 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_18 = { value: "" };
const _hoisted_19 = ["value"];
const _hoisted_20 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_21 = ["placeholder"];
const _hoisted_22 = { class: "flex items-end gap-2" };
const _hoisted_23 = { class: "overflow-x-auto" };
const _hoisted_24 = { class: "min-w-full divide-y divide-ewhite-100 text-left text-sm" };
const _hoisted_25 = { class: "bg-ewhite-50 text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_26 = { class: "px-4 py-3" };
const _hoisted_27 = { class: "px-4 py-3" };
const _hoisted_28 = { class: "px-4 py-3" };
const _hoisted_29 = { class: "px-4 py-3" };
const _hoisted_30 = { class: "px-4 py-3" };
const _hoisted_31 = { class: "px-4 py-3 text-right" };
const _hoisted_32 = { class: "divide-y divide-ewhite-100 bg-white" };
const _hoisted_33 = { key: 0 };
const _hoisted_34 = {
    colspan: "6",
    class: "px-4 py-8 text-center text-eblack-500"
};
const _hoisted_35 = { key: 1 };
const _hoisted_36 = {
    colspan: "6",
    class: "px-4 py-8 text-center text-eblack-500"
};
const _hoisted_37 = { class: "px-4 py-3 align-top" };
const _hoisted_38 = { class: "flex flex-col gap-1" };
const _hoisted_39 = { class: "font-mono text-xs text-eblack-500" };
const _hoisted_40 = { class: "text-xs text-eblack-500" };
const _hoisted_41 = { class: "px-4 py-3 align-top" };
const _hoisted_42 = { class: "flex flex-col gap-1" };
const _hoisted_43 = { class: "font-medium text-eblack-900" };
const _hoisted_44 = { class: "text-xs text-eblack-500" };
const _hoisted_45 = { class: "text-xs text-eblack-500" };
const _hoisted_46 = { class: "px-4 py-3 align-top text-eblack-600" };
const _hoisted_47 = { class: "flex flex-col gap-1" };
const _hoisted_48 = { class: "text-xs" };
const _hoisted_49 = { class: "max-w-xs px-4 py-3 align-top text-eblack-600" };
const _hoisted_50 = { class: "font-medium text-eblack-800" };
const _hoisted_51 = { class: "mt-1 line-clamp-2 text-xs text-eblack-500" };
const _hoisted_52 = { class: "px-4 py-3 align-top text-eblack-600" };
const _hoisted_53 = { class: "flex flex-col gap-1" };
const _hoisted_54 = { class: "text-xs text-eblack-500" };
const _hoisted_55 = { class: "px-4 py-3 align-top" };
const _hoisted_56 = { class: "flex justify-end" };
const _hoisted_57 = ["disabled", "onClick"];
const _hoisted_58 = { class: "flex flex-wrap items-center justify-between gap-3 border-t border-ewhite-100 px-4 py-3 text-sm text-eblack-500" };
const _hoisted_59 = ["disabled"];
import { computed, onMounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import { IconPlayerPlay, IconRefresh, IconRotateClockwise2, } from "@tabler/icons-vue";
import { notificationDeliveryOperationsRepository } from "@/domains/notification/repositories";
const PAGE_SIZE = 25;
export default /*@__PURE__*/ _defineComponent({
    __name: 'NotificationDeliveriesIndex',
    setup(__props) {
        const statuses = [
            "pending",
            "waiting_translation",
            "processing",
            "queued",
            "sent",
            "delivered",
            "skipped",
            "failed",
        ];
        const retryableStates = new Set([
            "due",
            "scheduled",
            "stale_processing",
            "terminal_failure",
        ]);
        const { t, locale } = useI18n();
        const toast = useToast();
        const isLoading = ref(false);
        const isLoadingMore = ref(false);
        const isRunningScheduler = ref(false);
        const retryingId = ref(null);
        const error = ref(null);
        const health = ref(null);
        const deliveries = ref([]);
        const pagination = reactive({
            limit: PAGE_SIZE,
            offset: 0,
            total: 0,
            has_more: false,
        });
        const filters = reactive({
            search: "",
            status: "failed",
            event_type: "",
        });
        const healthCards = computed(() => {
            const backlog = health.value?.backlog ?? {};
            return [
                {
                    key: "pending_due",
                    label: t("notifications.delivery_ops.health.pending_due"),
                    value: numberValue(backlog.pending_due),
                    detail: t("notifications.delivery_ops.health.pending_due_detail"),
                },
                {
                    key: "failed_24h",
                    label: t("notifications.delivery_ops.health.failed_24h"),
                    value: numberValue(backlog.failed_24h),
                    detail: t("notifications.delivery_ops.health.failed_24h_detail"),
                },
                {
                    key: "waiting_translation",
                    label: t("notifications.delivery_ops.health.waiting_translation"),
                    value: numberValue(backlog.waiting_translation),
                    detail: t("notifications.delivery_ops.health.waiting_translation_detail"),
                },
                {
                    key: "task_scheduling_failures",
                    label: t("notifications.delivery_ops.health.task_failures"),
                    value: numberValue(backlog.task_scheduling_failures),
                    detail: t("notifications.delivery_ops.health.task_failures_detail"),
                },
            ];
        });
        onMounted(() => {
            refresh();
        });
        async function refresh() {
            isLoading.value = true;
            error.value = null;
            try {
                const [nextHealth, nextDeliveries] = await Promise.all([
                    notificationDeliveryOperationsRepository.health(),
                    notificationDeliveryOperationsRepository.list(queryFor(0)),
                ]);
                health.value = nextHealth;
                deliveries.value = nextDeliveries.items;
                applyPagination(nextDeliveries.pagination);
            }
            catch (err) {
                error.value =
                    err instanceof Error
                        ? err.message
                        : t("notifications.delivery_ops.errors.load_failed");
            }
            finally {
                isLoading.value = false;
            }
        }
        async function loadMore() {
            if (isLoadingMore.value || !pagination.has_more)
                return;
            isLoadingMore.value = true;
            error.value = null;
            try {
                const response = await notificationDeliveryOperationsRepository.list(queryFor(deliveries.value.length));
                const seen = new Set(deliveries.value.map((delivery) => delivery.id));
                deliveries.value = [
                    ...deliveries.value,
                    ...response.items.filter((delivery) => !seen.has(delivery.id)),
                ];
                applyPagination(response.pagination);
            }
            catch (err) {
                error.value =
                    err instanceof Error
                        ? err.message
                        : t("notifications.delivery_ops.errors.load_more_failed");
            }
            finally {
                isLoadingMore.value = false;
            }
        }
        async function applyFilters() {
            await refresh();
        }
        async function clearFilters() {
            filters.search = "";
            filters.status = "";
            filters.event_type = "";
            await refresh();
        }
        async function runScheduler() {
            isRunningScheduler.value = true;
            error.value = null;
            try {
                await notificationDeliveryOperationsRepository.runScheduler(100);
                toast.success(t("notifications.delivery_ops.toasts.scheduler_run"));
                await refresh();
            }
            catch (err) {
                toast.error(t("notifications.delivery_ops.toasts.scheduler_failed"));
                error.value =
                    err instanceof Error
                        ? err.message
                        : t("notifications.delivery_ops.errors.scheduler_failed");
            }
            finally {
                isRunningScheduler.value = false;
            }
        }
        async function retryDelivery(delivery) {
            if (!canRetry(delivery))
                return;
            if (!window.confirm(t("notifications.delivery_ops.confirm_retry")))
                return;
            retryingId.value = delivery.id;
            error.value = null;
            try {
                await notificationDeliveryOperationsRepository.retry(delivery.id, {
                    reason: t("notifications.delivery_ops.retry_reason"),
                });
                toast.success(t("notifications.delivery_ops.toasts.retry_queued"));
                await refresh();
            }
            catch (err) {
                toast.error(t("notifications.delivery_ops.toasts.retry_failed"));
                error.value =
                    err instanceof Error
                        ? err.message
                        : t("notifications.delivery_ops.errors.retry_failed");
            }
            finally {
                retryingId.value = null;
            }
        }
        function queryFor(offset) {
            return {
                limit: PAGE_SIZE,
                offset,
                status: filters.status || undefined,
                event_type: filters.event_type || undefined,
                search: filters.search || undefined,
            };
        }
        function applyPagination(next) {
            pagination.limit = next.limit;
            pagination.offset = next.offset;
            pagination.total = next.total;
            pagination.has_more = next.has_more;
        }
        function canRetry(delivery) {
            return delivery.channel === "email" && retryableStates.has(delivery.retry_state);
        }
        function statusClass(status) {
            if (status === "failed")
                return "bg-red-50 text-red-700";
            if (status === "skipped")
                return "bg-amber-50 text-amber-700";
            if (status === "delivered" || status === "sent") {
                return "bg-green-50 text-green-700";
            }
            if (status === "processing" || status === "queued") {
                return "bg-blue-50 text-blue-700";
            }
            return "bg-ewhite-100 text-eblack-600";
        }
        function formatDate(value) {
            if (!value)
                return t("notifications.delivery_ops.none");
            return new Intl.DateTimeFormat(locale.value, {
                dateStyle: "medium",
                timeStyle: "short",
            }).format(new Date(value));
        }
        function numberValue(value) {
            return typeof value === "number" ? value : 0;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("notifications.delivery_ops.eyebrow")), 1),
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("notifications.delivery_ops.title")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex h-9 items-center gap-2 rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                            "data-test": "notification-deliveries-refresh",
                            disabled: isLoading.value || isRunningScheduler.value,
                            onClick: refresh
                        }, [
                            _createVNode(_unref(IconRefresh), { class: "h-4 w-4" }),
                            _createTextVNode(" " + _toDisplayString(_unref(t)("notifications.delivery_ops.actions.refresh")), 1)
                        ], 8, _hoisted_6),
                        _createElementVNode("button", {
                            type: "button",
                            class: "inline-flex h-9 items-center gap-2 rounded-lg bg-egreen-500 px-3 text-sm font-medium text-white hover:bg-egreen-600 disabled:opacity-60",
                            "data-test": "notification-deliveries-run-scheduler",
                            disabled: isLoading.value || isRunningScheduler.value,
                            onClick: runScheduler
                        }, [
                            _createVNode(_unref(IconPlayerPlay), { class: "h-4 w-4" }),
                            _createTextVNode(" " + _toDisplayString(isRunningScheduler.value
                                ? _unref(t)("notifications.delivery_ops.actions.running")
                                : _unref(t)("notifications.delivery_ops.actions.run_scheduler")), 1)
                        ], 8, _hoisted_7)
                    ])
                ]),
                _createElementVNode("section", _hoisted_8, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(healthCards.value, (card) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: card.key,
                            class: "rounded-lg border border-ewhite-200 bg-white p-4"
                        }, [
                            _createElementVNode("p", _hoisted_9, _toDisplayString(card.label), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(card.value), 1),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(card.detail), 1)
                        ]));
                    }), 128))
                ]),
                (error.value)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                        _createElementVNode("span", null, _toDisplayString(error.value), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-red-200 px-2.5 py-1 font-medium hover:bg-red-100",
                            onClick: refresh
                        }, _toDisplayString(_unref(t)("notifications.delivery_ops.actions.retry")), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("label", _hoisted_15, [
                            _createTextVNode(_toDisplayString(_unref(t)("notifications.delivery_ops.filters.search")) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filters.search) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                "data-test": "notification-deliveries-search",
                                placeholder: _unref(t)('notifications.delivery_ops.filters.search_placeholder'),
                                onKeydown: _withKeys(applyFilters, ["enter"])
                            }, null, 40, _hoisted_16), [
                                [
                                    _vModelText,
                                    filters.search,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_17, [
                            _createTextVNode(_toDisplayString(_unref(t)("notifications.delivery_ops.filters.status")) + " ", 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filters.status) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                "data-test": "notification-deliveries-status",
                                onChange: applyFilters
                            }, [
                                _createElementVNode("option", _hoisted_18, _toDisplayString(_unref(t)("notifications.delivery_ops.filters.any_status")), 1),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statuses, (status) => {
                                    return _createElementVNode("option", {
                                        key: status,
                                        value: status
                                    }, _toDisplayString(_unref(t)(`notifications.delivery_ops.statuses.${status}`)), 9, _hoisted_19);
                                }), 64))
                            ], 544), [
                                [_vModelSelect, filters.status]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_20, [
                            _createTextVNode(_toDisplayString(_unref(t)("notifications.delivery_ops.filters.event_type")) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filters.event_type) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                "data-test": "notification-deliveries-event-type",
                                placeholder: _unref(t)('notifications.delivery_ops.filters.event_type_placeholder'),
                                onKeydown: _withKeys(applyFilters, ["enter"])
                            }, null, 40, _hoisted_21), [
                                [
                                    _vModelText,
                                    filters.event_type,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50",
                                "data-test": "notification-deliveries-apply",
                                onClick: applyFilters
                            }, _toDisplayString(_unref(t)("notifications.delivery_ops.actions.apply")), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg px-3 text-sm font-medium text-eblack-500 hover:bg-ewhite-50",
                                "data-test": "notification-deliveries-clear",
                                onClick: clearFilters
                            }, _toDisplayString(_unref(t)("notifications.delivery_ops.actions.clear")), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("table", _hoisted_24, [
                            _createElementVNode("thead", _hoisted_25, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", _hoisted_26, _toDisplayString(_unref(t)("notifications.delivery_ops.table.delivery")), 1),
                                    _createElementVNode("th", _hoisted_27, _toDisplayString(_unref(t)("notifications.delivery_ops.table.event")), 1),
                                    _createElementVNode("th", _hoisted_28, _toDisplayString(_unref(t)("notifications.delivery_ops.table.recipient")), 1),
                                    _createElementVNode("th", _hoisted_29, _toDisplayString(_unref(t)("notifications.delivery_ops.table.failure")), 1),
                                    _createElementVNode("th", _hoisted_30, _toDisplayString(_unref(t)("notifications.delivery_ops.table.next_attempt")), 1),
                                    _createElementVNode("th", _hoisted_31, _toDisplayString(_unref(t)("notifications.delivery_ops.table.actions")), 1)
                                ])
                            ]),
                            _createElementVNode("tbody", _hoisted_32, [
                                (isLoading.value)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [
                                        _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(t)("notifications.delivery_ops.loading")), 1)
                                    ]))
                                    : (deliveries.value.length === 0)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_35, [
                                            _createElementVNode("td", _hoisted_36, _toDisplayString(_unref(t)("notifications.delivery_ops.empty")), 1)
                                        ]))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(deliveries.value, (delivery) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: delivery.id,
                                                "data-test": "notification-delivery-row"
                                            }, [
                                                _createElementVNode("td", _hoisted_37, [
                                                    _createElementVNode("div", _hoisted_38, [
                                                        _createElementVNode("span", _hoisted_39, "#" + _toDisplayString(delivery.id), 1),
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["w-fit rounded-full px-2 py-0.5 text-xs font-semibold", statusClass(delivery.status)])
                                                        }, _toDisplayString(_unref(t)(`notifications.delivery_ops.statuses.${delivery.status}`)), 3),
                                                        _createElementVNode("span", _hoisted_40, _toDisplayString(delivery.channel) + " · " + _toDisplayString(_unref(t)(`notifications.delivery_ops.retry_states.${delivery.retry_state}`)), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_41, [
                                                    _createElementVNode("div", _hoisted_42, [
                                                        _createElementVNode("span", _hoisted_43, _toDisplayString(delivery.event.type), 1),
                                                        _createElementVNode("span", _hoisted_44, _toDisplayString(delivery.event.resource.type) + ":" + _toDisplayString(delivery.event.resource.id), 1),
                                                        _createElementVNode("span", _hoisted_45, [
                                                            _createTextVNode(_toDisplayString(delivery.template.key || _unref(t)("notifications.delivery_ops.none")) + " ", 1),
                                                            (delivery.template.locale)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _createTextVNode(" · " + _toDisplayString(delivery.template.locale), 1)
                                                                ], 64))
                                                                : _createCommentVNode("", true)
                                                        ])
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_46, [
                                                    _createElementVNode("div", _hoisted_47, [
                                                        _createElementVNode("span", null, _toDisplayString(delivery.recipient.audience_type || _unref(t)("notifications.delivery_ops.none")), 1),
                                                        _createElementVNode("span", _hoisted_48, _toDisplayString(_unref(t)("notifications.delivery_ops.org")) + " " + _toDisplayString(delivery.recipient.org_id || "—"), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_49, [
                                                    _createElementVNode("p", _hoisted_50, _toDisplayString(delivery.failure_code || _unref(t)("notifications.delivery_ops.none")), 1),
                                                    _createElementVNode("p", _hoisted_51, _toDisplayString(delivery.failure_summary || _unref(t)("notifications.delivery_ops.no_failure_summary")), 1)
                                                ]),
                                                _createElementVNode("td", _hoisted_52, [
                                                    _createElementVNode("div", _hoisted_53, [
                                                        _createElementVNode("span", null, _toDisplayString(formatDate(delivery.next_attempt_at)), 1),
                                                        _createElementVNode("span", _hoisted_54, _toDisplayString(_unref(t)("notifications.delivery_ops.attempts", { count: delivery.attempt_count })), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_55, [
                                                    _createElementVNode("div", _hoisted_56, [
                                                        _createElementVNode("button", {
                                                            type: "button",
                                                            class: "inline-flex h-8 items-center gap-1 rounded-lg border border-ewhite-200 px-2.5 text-xs font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-50",
                                                            "data-test": "notification-delivery-retry",
                                                            disabled: !canRetry(delivery) || retryingId.value === delivery.id,
                                                            onClick: ($event) => (retryDelivery(delivery))
                                                        }, [
                                                            _createVNode(_unref(IconRotateClockwise2), { class: "h-4 w-4" }),
                                                            _createTextVNode(" " + _toDisplayString(_unref(t)("notifications.delivery_ops.actions.retry_delivery")), 1)
                                                        ], 8, _hoisted_57)
                                                    ])
                                                ])
                                            ]));
                                        }), 128))
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_58, [
                        _createElementVNode("span", null, _toDisplayString(_unref(t)("notifications.delivery_ops.pagination", { count: deliveries.value.length, total: pagination.total })), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "h-9 rounded-lg border border-ewhite-200 px-3 font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                            "data-test": "notification-deliveries-load-more",
                            disabled: isLoadingMore.value || !pagination.has_more,
                            onClick: loadMore
                        }, _toDisplayString(isLoadingMore.value
                            ? _unref(t)("notifications.delivery_ops.actions.loading_more")
                            : _unref(t)("notifications.delivery_ops.actions.load_more")), 9, _hoisted_59)
                    ])
                ])
            ]));
        };
    }
});
